<template lang="pug">
y-dialog(v-if="showDialog" v-model="showDialog" max-width="800" persistent fluid scrollable content-class="round-2xl")
  v-card(height="80vh")
    v-card-title.pa-4
      v-spacer
      .text-xl.font-bold.ml-10 New tier
      v-spacer
      v-btn(icon @click="closeDialog" small color="primary")
        v-icon mdi-close
    v-divider
    v-card-text.px-2.py-0
      div.d-flex.justify-center.mt-16(v-if="isFetching")
        v-progress-circular(:width="2" :size="50" color="primary" indeterminate)
      v-form(v-else ref="form")
        v-row(no-gutters)
          v-col.pa-4
            .text-sm.font-semibold.neutral700--text Tier name
            v-text-field.text-sm.mt-2.round-xl(v-model="tier.name" placeholder="Enter tier name" outlined dense height="48" :rules="rules.not_empty" hide-details="auto")
            .text-sm.font-semibold.neutral700--text.mt-4 Description (optional)
            v-textarea.text-sm.mt-2.round-xl(v-model="tier.description" placeholder="Enter tier description (optional)" outlined rows="3" hide-details="auto")
            template(v-if="parentTier")
              .text-sm.font-semibold.neutral700--text.mt-4 Status
              y-select.mt-2(v-model="tier.status" :items="statuses" item-text="text" item-value="value" :rules="rules.not_empty_select")

          v-divider(vertical)
          v-col.pa-4
            .text-sm.font-semibold.neutral700--text Payment method
            div(style="height: 50vh; overflow: auto")
              div.mt-4
                y-checkbox(v-model="pmSelfPay" @change="tickSelfPay")
                  template(#label)
                    .text-sm.neutral700--text Self pay
                div.ml-4
                  template(v-for="selfpay in selfpayList")
                    y-checkbox.mt-1(v-model="tier.self_pay" :value="selfpay.id" @change="checkSelfPay" :key="selfpay.id")
                      template(#label)
                        .text-sm.neutral700--text {{ selfpay.name }}
              div.mt-3
                y-checkbox(v-model="pmPanel" @change="tickPanel")
                  template(#label)
                    .text-sm.neutral700--text Panel
                div.ml-4
                  template(v-for="panel in panels")
                    y-checkbox.mt-1(v-model="tier.panels" :value="panel.id" @change="checkPanel" :key="panel.id")
                      template(#label)
                        .text-sm.neutral700--text {{ panel.name }}
          
    v-divider
    v-card-actions.py-4.px-6
      v-btn.button-md.underline.px-0(@click="closeDialog" text) {{ $t('cancel') }}
      v-spacer
      v-btn.button-md(color="primary" depressed @click="saveData" :loading="isLoading") {{ $t('save') }}
      

</template>

<script>
import { mapGetters, mapActions } from 'vuex'

export default {
  components: {},
  props: {
    open: {
      type: Boolean,
      default: false
    },
    parentTier: {
      default: null
    }
  },
  data: () => ({
    isFetching: false,
    isLoading: false,
    pmSelfPay: false,
    pmPanel: false,
    panels: [],
    selfpayList: [],
    statuses: [
      { text: 'Active', value: 'active' },
      { text: 'Archived', value: 'archived' },
    ],
    tier: {
      self_pay: [],
      panels: []
    },
    rules: {
      not_empty: [val => (val || '').length > 0 || 'This field is required'],
      has_quantity: [v => !!v || 'This field is required', v => v != 0 || 'This field is required'],
      has_price: [(v) => !!v || 'This field is required', (v) => v >= 1|| `Amount should be more than ${this.$currency.symbol} 1`],
      not_empty_select: [v => !!v || 'This field is required']
    },
  }),
  computed: {
    ...mapGetters({ company: 'getCompany' }),
    showDialog: {
      get () {
        return this.open 
      },
      set (newValue) {
        this.$emit('update:open', newValue)
      }
    },
  },
  mounted () {
    this.fetchPanels()
    if (this.parentTier) {
      if (this.parentTier.panels.length > 0) {
        this.pmPanel = true
      }
      if (this.parentTier.self_pay.length > 0) {
        this.pmSelfPay = true
      }
      this.tier = {
        ...this.parentTier,
        panels: this.parentTier.panels.map(m => m.id),
        self_pay: this.parentTier.self_pay.map(m => m.id)
      }
    }
  },
  methods: {
    ...mapActions(['showMessage']),
    fetchPanels () {
      this.isFetching = true
      let params = {
       page_size: -1,
       company: this.company.id,
       enabled: true
      }
      this.$axios.get(`/payment_methods`, { params })
        .then(resp => {
          if (resp.data && resp.data.results) {
            let payment_method = resp.data.results
            this.selfpayList = payment_method.filter(f => f.channel === 'self-pay')
            this.panels = payment_method.filter(f => f.channel === 'panel')
          }
        })
        .catch(() => {
          this.showMessage(['error', this.$t('error_message.unable_to_complete_request')])
        })
        .finally(() => {
          this.isFetching = false
        })
    },
    saveData () {
      if (!this.$refs.form.validate()) {
        return
      }
      this.isLoading = true
      if (this.parentTier) {
        let data = {
          company: this.company.id,
          name: this.tier.name,
          description: this.tier.description,
          status: this.tier.status,
          payment_methods: this.tier.self_pay.concat(this.tier.panels)
        }
        this.$axios.put(`/product_pricetiers/${this.parentTier.id}`, data)
          .then(() => {
            this.$emit('reset')
            this.closeDialog
          })
          .catch(() => {
            this.showMessage(['error', this.$t('error_message.unable_to_complete_request')])
          })
          .finally(() => {
            this.isLoading = false
          })
      } else {
        let data = {
          company: this.company.id,
          name: this.tier.name,
          description: this.tier.description,
          payment_methods: this.tier.self_pay.concat(this.tier.panels)
        }
        this.$axios.post('/product_pricetiers', data)
          .then(() => {
            this.$emit('reset')
            this.closeDialog
          })
          .catch(() => {
            this.showMessage(['error', this.$t('error_message.unable_to_complete_request')])
          })
          .finally(() => {
            this.isLoading = false
          })
      }
    },
    closeDialog () {
      this.$emit('closed')
    },
    checkSelfPay () {
      if (this.tier.self_pay.length > 0) {
        this.pmSelfPay = true
      } else {
        this.pmSelfPay = false
      }
    },
    tickSelfPay () {
      if (this.pmSelfPay) {
        this.tier.self_pay = this.selfpayList.map(m => m.id)
      } else {
        this.tier.self_pay = []
      }
    },
    checkPanel () {
      if (this.tier.panels.length > 0) {
        this.pmPanel = true
      } else {
        this.pmPanel = false
      }
    },
    tickPanel () {
      if (this.pmPanel) {
        this.tier.panels = this.panels.map(m => m.id)
      } else {
        this.tier.panels = []
      }
    }
  }
}
</script>

<style lang="scss" scoped>
::v-deep {
  .v-text-field--outlined {
    fieldset {
      border-color: var(--v-neutral400);
    }
  } 
  .error--text {
    color: var(--v-danger500) !important;
    fieldset {
      border-color: var(--v-danger500);
    }
  }
}
</style>